export const he: Record<string, string> = {
  // Nav
  "nav.home": "בית",
  "nav.play": "נגן",
  "nav.lists": "פלייליסטים",
  "nav.praktis": "פלייליסטים",
  "nav.achievements": "הישגים",
  "nav.profile": "פרופיל",
  "nav.more": "עוד",
  "nav.challenge": "אתגר",
  "nav.h2h": "דו-קרב",
  "nav.party": "מסיבה",
  "nav.uncover": "עקבות",

  // Home
  "home.greeting": "שלום וברכה",
  "home.subgreeting": "מה מנגנים היום?",
  "home.menu": "תפריט",
  "home.stats.streak": "רצף משחק",
  "home.stats.streak.days": "{n} ימים ברציפות",
  "home.stats.points": "נקודות",
  "home.recommended": "מומלץ להיום",
  "home.daily.label": "אתגר יומי",
  "home.daily.title": "הניגון היומי",
  "home.daily.subtitle": "ניגון אחד, עד 6 תווים.",
  "home.daily.cta": "נגן עכשיו",
  "home.daily.pill.new": "חדש היום",
  "home.daily.footer": "+80 נק׳ בהצלחה מושלמת",
  "home.praktis.label": "מצב חופשי · ללא הגבלה",
  "home.praktis.title": "פראקטיס־שפיל",
  "home.praktis.subtitle": "בחר פלייליסט, נגן לבד או עם חברים.",
  "home.praktis.cta": "עיין בפלייליסטים ←",
  "home.praktis.footer": "",
  "home.continue.title": "המשך ניגון",

  // Praktis
  "praktis.title": "פּראַקטיס־שפּיל",
  "praktis.subtitle": "בחר פלייליסט. ללא הגבלת ניסיונות.",

  // Profile / share
  "common.profile": "פרופיל",
  "profile.shareText": "בוא לשחק ניגונים!",

  // Uncover
  "uncover.tapToPlay": "התחלה",
  "uncover.clue.plus": "רמז",
  "uncover.clue.decade": "עשור",
  "uncover.clue.genre": "ז'אנר",
  "uncover.clue.wordCount": "שם השיר",
  "uncover.clue.wordCountValue": "{n} מילים",
  "uncover.clue.artist": "אמן",
  "uncover.clue.extraNote": "עוד תו",
  "uncover.knewItQuestion": "הכרת את השיר?",
  "uncover.knewItYes": "כן, הכרתי",
  "uncover.knewItNo": "לא, בפעם הראשונה",
  "uncover.nailedIt": "ניחשת!",
  "uncover.knewItLabel": "הכרת",
  "uncover.missed": "נחשף",
  "uncover.afterClues": "ניחשת אחרי {n} רמזים",
  "uncover.noPointsHint": "בלי נקודות — אבל עכשיו אתה יודע",
  "uncover.weekly.title": "עקבות השבוע",
  "uncover.weekly.startCta": "התחל אתגר שבועי",
  "uncover.weekly.continueCta": "המשך לשיר הבא",
  "uncover.weekly.completed": "✓ השלמת את כל השירים השבוע",
  "nav.board": "טבלה",
  "nav.jukebox": "מיקס",

  // Common
  "common.signIn": "התחברות",
  "common.signOut": "התנתקות",
  "common.cancel": "ביטול",
  "common.join": "הצטרפות",
  "common.back": "חזרה →",
  "common.loading": "טוען...",
  "common.or": "או הצטרפו",
  "common.enterCode": "הכניסו קוד...",
  "common.discover": "גילוי",
  "common.clue": "+ רמז",
  "common.nextSong": "← השיר הבא",
  "common.tryAgain": "נסו שוב",
  "common.end": "סיום",
  "common.songs": "שירים",
  "common.score": "ניקוד",
  "common.streak": "רצף",
  "common.pts": "נק׳",
  "common.played": "שוחקו",

  // Cookie consent
  "cookie.message": "אנחנו משתמשים בעוגיות לשיפור החוויה.",
  "cookie.accept": "אישור",
  "cookie.decline": "דחייה",

  // Offline / Update / Error
  "offline.message": "אתם לא מחוברים — האתגר היומי עדיין זמין",
  "update.available": "גרסה חדשה זמינה",
  "update.refresh": "רענון",
  "error.title": "משהו השתבש",
  "error.reload": "טעינה מחדש",

  // App
  "app.silentMode": "כבו מצב שקט לשמיעת אודיו",
  "app.copyright": "© 2024–2026 ניגונים. כל הזכויות שמורות.",

  // Guess input
  "guess.placeholder": "הקלידו שם שיר או אמן...",

  // Share
  "share.whatsapp": "שתפו בוואטסאפ",
  "share.result": "שתפו תוצאה",
  "share.copied": "הועתק!",
  "share.invite": "הזמינו חברים",
  "share.inviteText": "חושבים שאתם מכירים ניגונים? נסו את ניגונים — נחשו את הניגון תו אחד בכל פעם!\nhttps://niggunim.net",

  // Daily Challenge
  "daily.title": "אתגר יומי #{num}",
  "daily.tapToPlay": "לחצו להתחיל",
  "daily.nextChallenge": "האתגר הבא בעוד",
  "daily.hrs": "שעות",
  "daily.min": "דקות",
  "daily.sec": "שניות",
  "daily.gotIt": "פיצחתם ב-♪{stage}!",
  "daily.betterLuck": "מחר יהיה יותר טוב",
  "daily.incredible": "מדהים!",
  "daily.brilliant": "מעולה!",
  "daily.nice": "יפה!",
  "daily.youGotIt": "פיצחתם ב-{stage}!",
  "daily.attempt": "ניסיון",
  "daily.points": "נקודות",
  "daily.tryTomorrow": "נסו שוב מחר",
  "daily.songUnavailable": "השיר לא זמין, טוען את הבא...",
  "daily.viewLeaderboard": "צפו בטבלה",
  "daily.thisWeek": "השבוע",
  "daily.startWeekly": "התחילו אתגר שבועי",
  "daily.continuePlaying": "המשיכו לשחק",
  "daily.loadingWeekly": "טוען אתגר שבועי...",
  "daily.daily": "יומי",
  "daily.weekly": "שבועי",

  // H2H
  "h2h.title": "דו-קרב",
  "h2h.subtitle": "אתגרו חבר לראות מי מכיר מוזיקה טוב יותר",
  "h2h.signIn": "התחברו כדי לשחק דו-קרב",
  "h2h.signInCreate": "התחברו כדי ליצור אתגרים",
  "h2h.challengeFriend": "אתגרו חבר",
  "h2h.songs": "שירים",
  "h2h.quickDuel": "דו-קרב מהיר",
  "h2h.bestOf3": "הטוב מ-3",
  "h2h.fullBattle": "קרב מלא",
  "h2h.song": "שיר {n}",
  "h2h.songPlural": "{n} שירים",
  "h2h.playlist": "פלייליסט",
  "h2h.randomAll": "אקראי (כל השירים)",
  "h2h.creating": "יוצר...",
  "h2h.createChallenge": "צרו אתגר",
  "h2h.challengeNotFound": "האתגר לא נמצא או כבר שוחק.",
  "h2h.createFailed": "יצירת האתגר נכשלה. נסו שוב.",
  "h2h.invalidCode": "קוד לא תקין או שפג תוקפו.",
  "h2h.recentDuels": "דו-קרבות אחרונים",
  "h2h.whatsapp": "וואטסאפ",
  "h2h.youCreated": "יצרתם",
  "h2h.youJoined": "הצטרפתם",
  "h2h.waiting": "ממתינים ליריב",
  "h2h.shareLink": "שתפו את הקישור",
  "h2h.sendWhatsApp": "שלחו בוואטסאפ",
  "h2h.waitingJoin": "ממתינים שמישהו יצטרף...",
  "h2h.opponentJoined": "היריב הצטרף — מתחילים...",
  "h2h.copyLink": "העתיקו קישור",
  "h2h.linkCopied": "הועתק ✓",
  "h2h.viewResult": "תוצאה",
  "h2h.deleteChallenge": "מחק אתגר",
  "h2h.stillPlaying": "עדיין משחק",
  "h2h.opponentFinishedTitle": "היריב סיים!",
  "h2h.opponentFinishedBody": "היריב שלך סיים — {score} נק׳. מצליחים לעבור?",
  "h2h.startNow": "התחילו לשחק עכשיו (היריב יצטרף אחר כך)",
  "h2h.joinChallenge": "הצטרפו לאתגר",
  "h2h.duel": "דו-קרב",
  "h2h.songProgress": "שיר {current} / {total}",
  "h2h.scoresIn": "הניקוד שלכם נרשם!",
  "h2h.youWon": "ניצחתם!",
  "h2h.tie": "תיקו!",
  "h2h.youLost": "הפסדתם!",
  "h2h.you": "אתם",
  "h2h.opponent": "יריב",
  "h2h.opponentPending": "שתפו את הקוד {code} — היריב עוד לא שיחק.",
  "h2h.backToH2H": "חזרה לדו-קרב",
  "h2h.challengeText": "אני מאתגר אותך בניגונים! תצליחו לנחש את השירים?\n{url}",

  // Party
  "party.title": "מצב מסיבה",
  "party.subtitle": "שחקו עם חברים",
  "party.description": "שחקו עם חברים באותו חדר",
  "party.tagline": "דיג'יי אחד, כולם מנחשים. כמו Hitster, בחינם.",
  "party.signIn": "התחברו כדי לשחק",
  "party.gameType": "סוג משחק",
  "party.buzzer": "באזר",
  "party.turns": "תורות",
  "party.buzzerDesc": "הראשון שמנחש מקבל נקודה",
  "party.turnsDesc": "כל שחקן מנחש בתורו",
  "party.createRoom": "צרו חדר",
  "party.inviteWhatsApp": "הזמינו דרך וואטסאפ",
  "party.players": "שחקנים ({count})",
  "party.dj": "DJ",
  "party.waitingPlayers": "ממתינים לשחקנים...",
  "party.startGame": "התחילו משחק",
  "party.startSolo": "התחילו לבד",
  "party.songCount": "מסיבה • שיר {count}",
  "party.endGame": "סיימו משחק",
  "party.gameOver": "המשחק נגמר",
  "party.finalScores": "תוצאות סופיות",
  "party.songsPlayed": "{count} שירים שוחקו",
  "party.newGame": "משחק חדש",
  "party.inviteText": "הצטרפו למסיבת ניגונים שלי!\nקוד חדר: {code}\n{url}",
  "party.copyLink": "העתיקו קישור",
  "party.linkCopied": "הועתק ✓",
  "party.room": "חדר {code}",
  "party.modeLabel": "מצב מסיבה · {mode}",

  // Leaderboard
  "board.title": "טבלת מובילים",
  "board.period": "תקופה",
  "board.topPlayers": "השחקנים המובילים",
  "board.thisWeek": "השבוע",
  "board.allTime": "כל הזמנים",
  "board.noScores": "אין תוצאות עדיין השבוע.",
  "board.playDaily": "שחקו באתגר היומי כדי להופיע כאן!",
  "board.games": "{count} משחקים",
  "board.bestStage": "הכי טוב ♪{stage}",

  // Jukebox
  "jukebox.endless": "∞ מצב אינסופי",
  "jukebox.endlessDesc": "שירים אקראיים, בלי גבול. כמה רחוק תגיעו?",
  "jukebox.allTime": "הקלאסיקות הגדולות",
  "jukebox.easy": "קל",
  "jukebox.medium": "בינוני",
  "jukebox.allSongs": "כל השירים",
  "jukebox.easyDesc": "הלהיטים הגדולים שכולם מכירים",
  "jukebox.mediumDesc": "שירים מוכרים מכל התקופות",
  "jukebox.allDesc": "הקטלוג המלא — רק למומחים",
  "jukebox.beginner": "למתחילים",
  "jukebox.someClassics": "קלאסיקות",
  "jukebox.challengeMode": "מצב אתגר",
  "jukebox.playlists": "פלייליסטים",
  "jukebox.loadError": "טעינת הפלייליסטים נכשלה. בדקו את החיבור.",
  "jukebox.backToPlaylists": "חזרה לפלייליסטים →",
  "jukebox.correct": "נכון",
  "jukebox.seeResults": "צפו בתוצאות",
  "jukebox.complete": "הפלייליסט הושלם!",
  "jukebox.accuracy": "{percent}% דיוק",
  "jukebox.songUnavailable": "השיר לא זמין",
  "jukebox.songUnavailableDesc": "לא ניתן לטעון את השיר הבא. זה יכול לקרות בגלל בעיות רשת זמניות.",

  // Profile
  "profile.title": "הפרופיל שלכם",
  "profile.signInDesc": "התחברו כדי לעקוב אחרי הסטטיסטיקות שלכם ולהתחרות",
  "profile.signInGoogle": "התחברות עם Google",
  "profile.lifetimeScore": "ניקוד כולל",
  "profile.gamesPlayed": "משחקים ששוחקו",
  "profile.streakMilestones": "אבני דרך ברצף",
  "profile.bestDays": "שיא: {count} ימים",
  "profile.badges": "תגים",
  "profile.joined": "הצטרפו ב-{date}",
  "profile.addToHome": "הוסיפו למסך הבית",
  "profile.shareProfile": "שתפו פרופיל",
  "profile.contactUs": "צרו קשר",
  "profile.deleteAccount": "מחיקת חשבון",
  "profile.deleteAccountConfirm": "פעולה זו תמחק לצמיתות את החשבון, הסטטיסטיקות והפרופיל שלך. להמשיך?",
  "profile.deleteAccountConfirm2": "אישור אחרון: למחוק לצמיתות?",
  "profile.deleteAccountDone": "החשבון נמחק.",
  "profile.deleteAccountFailed": "מחיקה נכשלה. נסה שוב או פנה אלינו.",
  "profile.linkCopied": "הקישור הועתק!",
  "profile.days": "{count} ימים",
  "profile.badge.streaker": "רצף",
  "profile.badge.quickRiff": "נגן זריז",
  "profile.badge.champion": "אלוף",
  "profile.badge.audiophile": "מאזין נלהב",
  "profile.installIOS.safari": "לחצו על כפתור השיתוף בתחתית הספארי, ואז \"הוספה למסך הבית\"",
  "profile.installIOS.other": "להתקנה, פתחו את העמוד בספארי, ואז לחצו על שיתוף → \"הוספה למסך הבית\"",
  "profile.continueAsGuest": "המשך כאורח",

  // How to Play
  "howto.rules": "החוקים",
  "howto.title": "איך משחקים?",
  "howto.subtitle": "חושבים שאתם מבינים בניגונים? בואו נראה.\nתו אחד בכל פעם.",
  "howto.step1Title": "שומעים תו אחד",
  "howto.step1Desc": "אנחנו משמיעים תו אחד מניגון. כן, תו אחד בלבד.\nיכול להיות קלידים, גיטרה או אורגן.\nנו, נראה אתכם.",
  "howto.step2Title": "מנחשים את הניגון",
  "howto.step2Desc": "כותבים את הניחוש שלכם.\nיש השלמה אוטומטית שתעזור עם האיות.\nאם תפסתם כבר בתו הראשון — שפיץ.",
  "howto.step3Title": "לא בטוחים? ממשיכים",
  "howto.step3Desc": "לא סגורים? אפשר לשמוע עוד תו.\nיש עד 6 תווים.\nכל תו נוסף מוריד נקודות.\nרגע, נישט אזוי שנעל.",
  "howto.step4Title": "ניקוד ושיתוף",
  "howto.step4Desc": "♪1 = 6 נקודות (שפיץ)\n♪6 = נקודה אחת (נו, גם זה משהו)\n0 = לא נעים…\n\nסיימתם? שתפו את התוצאה.",
  "howto.scoring": "ניקוד",
  "howto.miss": "פספוס",
  "howto.gameModes": "מצבי משחק",
  "howto.dailyTitle": "אתגר יומי",
  "howto.dailyDesc": "אותו ניגון לכולם. ניסיון אחד ביום.\nנגמר? תחזרו מחר.",
  "howto.endlessTitle": "פראקטיס־שפיל",
  "howto.endlessDesc": "ניגון אחרי ניגון, בלי הגבלה.\nתראו כמה אתם מחזיקים רצף בלי להתבלבל.",
  "howto.playlistTitle": "פלייליסטים",
  "howto.playlistDesc": "בוחרים נושא — שבת, חסידי, שמחות ועוד.\nמשחקים רק עם ניגונים מתוך הרשימה.",
  "howto.weeklyTitle": "אתגר שבועי",
  "howto.weeklyDesc": "כל שבוע מערכת ניגונים חדשה.\nמתחרים על הרצף הגבוה ביותר עד מוצ\"ש.",
  "howto.h2hTitle": "דו-קרב",
  "howto.h2hDesc": "מזמינים חבר. אותם ניגונים, אותם תווים. מי שמנחש מהר יותר מנצח.",
  "howto.boardTitle": "טבלת מובילים",
  "howto.boardDesc": "דירוגים שבועיים ולכל הזמנים. בקרוב!",

  // Install
  "install.streak": "רצף של {count} ימים! התקינו את ניגונים לגישה מהירה",
  "install.default": "אתם ברצף! התקינו את ניגונים לגישה מהירה",
  "install.button": "התקנה",

  // Notifications
  "notif.title": "אל תאבדו את הרצף",
  "notif.subtitle": "קבלו תזכורת לפני שהוא נשבר",
  "notif.button": "שלחו לי תזכורת",

  // Share landing
  "shareLanding.gotIt": "{name} פיצח/ה ב-♪{stage}!",
  "shareLanding.failed": "{name} לא הצליח/ה היום",
  "shareLanding.beatThat": "תצליחו לנצח?",
  "shareLanding.challengeBack": "⚔️ אתגר חזרה",
  "shareLanding.playToday": "שחקו באתגר היומי",
  "shareLanding.howDoesItWork": "איך זה עובד?",

  // Weekly
  "weekly.complete": "האתגר השבועי הושלם!",
  "weekly.leaderboard": "טבלת מובילים",

  // Onboarding
  "onboarding.letsPlay": "בואו נשחק!",
  "onboarding.skipIntro": "דלגו",
  "onboarding.tagline": "תזהו את השיר?",

  // Legal
  "legal.privacyPolicy": "מדיניות פרטיות",
  "legal.terms": "תנאי שימוש",
  "legal.accessibility": "נגישות",
};
